"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLoadCategories = void 0;
const react_1 = require("react");
const predicate_language_1 = require("@groupby/predicate-language");
const ramda_1 = require("ramda");
const react_redux_1 = require("react-redux");
const hooks_1 = require("../../hooks");
const localization_1 = require("../../localization");
const store_1 = require("../../store");
const utils_1 = require("../../utils");
const useLoadCategories = ({ filter } = {}) => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const client = (0, hooks_1.useEnrichClient)();
    const { addError } = (0, hooks_1.useNotification)();
    const { formatMessage: t } = (0, localization_1.useLocalization)();
    const selectedOrganizations = (0, store_1.useSelectedOrganizationsSelector)();
    const [isLoading, setIsLoading] = (0, react_1.useState)(false);
    const activeFilter = (0, react_1.useMemo)(() => {
        const categoriesFilter = new predicate_language_1.PredicateBuilder((0, predicate_language_1.where)((0, predicate_language_1.f) `organizationId`, '@<', selectedOrganizations.map(({ id }) => (0, predicate_language_1.uuid)(id))));
        return filter ? categoriesFilter.and(filter) : categoriesFilter;
    }, [filter, selectedOrganizations]);
    const loadCategories = (0, react_1.useCallback)(() => __awaiter(void 0, void 0, void 0, function* () {
        setIsLoading(true);
        dispatch((0, store_1.categoriesResetData)());
        try {
            const categories = yield (0, utils_1.getAllData)(client.categories, activeFilter);
            dispatch((0, store_1.categoriesSetCategories)((0, ramda_1.flatten)(categories)));
        }
        catch (err) {
            addError(t({ key: 'CATEGORIES_FAIL_LOAD' }));
        }
        finally {
            setIsLoading(false);
        }
    }), [addError, client.categories, dispatch, t, activeFilter]);
    return {
        loadCategories,
        isLoading,
    };
};
exports.useLoadCategories = useLoadCategories;
exports.default = exports.useLoadCategories;
